import React from "react"
import { Link } from "gatsby"

import Button from "./button"
import YourBPLogo from "../../images/logo-your-bp.png"

const CTAEnroll = ({
  className,
  copy,
  btncopy,
  url,
  site="gist",
  buttontheme="",
  btntexttransform="none",
  target
}) => {
  return (
    <>
      <div className="row cta-enroll">
        <div className="column small-12 medium-4 center your-bp-image"><img src={YourBPLogo} className="img-your-bp-logo" alt="Your Blueprint Logo" /></div>
        <div className="column small-12 medium-8 cta-enroll-headline vline">
          <h5 className="cta-enroll-headline-copy" dangerouslySetInnerHTML={{ __html: copy }}></h5>
          <div className="cta-enroll-button center">
            <Button copy={btncopy} url={url} site={site} buttontheme={buttontheme} texttransform={btntexttransform} target={target}/>
          </div>
        </div>
      </div>
    </>
  )
}

export default CTAEnroll
